<template>
  <modal v-model="isVisible">
    <form id="link-user" @submit.prevent="onSubmit">
      <div class="c-modalCard">
        <header class="c-modalCard__header">
          <h4 class="c-modalCard__title">Vincular email</h4>
          <a role="button" class="c-modalCard__close" v-on:click="close">
            <i class="i-remove"></i>
          </a>
        </header>
        <div class="c-modalCard__body">
          <div class="l-row">
            <form-group :columns="12" label="Email">
              <input autofocus type="text" class="form-input" id="email" v-model="email">
            </form-group>
          </div>
        </div>
        <footer class="c-modalCard__footer">
          <button type="button" class="btn btn--default" @click="close">Fechar</button>
          <button v-bind:class="{ 'is-loading': syncing }" :disabled="!canSync || syncing" type="submit" class="btn btn--primary">Vincular</button>
        </footer>
      </div>
    </form>
  </modal>
</template>

<script>
  import { mapActions } from 'vuex'
  import FormGroup from '@/components/template/FormGroup'
  import notifier from '@/notifier'

  export default {
    data: () => ({
      modal: null,
      isVisible: false,
      email: null,
      syncing: false
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      callback: {
        type: Function,
        required: false
      }
    },
    created () {
      this.isVisible = this.value
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      ...mapActions('user', [
        'linkUser'
      ]),
      confirm () {
        this.$emit('optionLink', true)
        this.close()
      },
      close () {
        delete document.body.onkeyup
        delete this.modal.onclick
        this.isVisible = false
      },
      async onSubmit () {
        this.syncing = true
        try {
          await this.link(this.email)

          this.clearFields()
          this.close()
          this.$emit('search')
        } catch (err) {
          notifier.error(err, 'Erro')
        }
        this.syncing = false
      },
      async link (email) {
        await this.linkUser(email)
      },
      clearFields () {
        this.email = null
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    },
    components: {
      FormGroup
    },
    computed: {
      canSync () {
        return this.email !== null && !!this.email.length
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ModalLinkUser.vue?ad152746